import { Controller } from '@hotwired/stimulus'
import Sortable from 'sortablejs'

export default class extends Controller {
    static values = {
        animation: Number,
        handle: String,
    }
    static targets = ['columnName']

    get options() {
        return {
            animation: this.animationValue || this.defaultOptions.animation || 150,
            handle: this.handleValue || this.defaultOptions.handle || undefined,
            onUpdate: this.onUpdate,
            onStart: this.onStart.bind(this),
            onEnd: this.onEnd.bind(this),
            selectedClass: 'sortable-selected',
        }
    }

    get defaultOptions() {
        return {}
    }

    initialize() {
        this.onUpdate = this.onUpdate.bind(this)
        this.table = this.element.closest('table')
    }

    connect() {
        this.sortable = new Sortable(this.element, {
            ...this.defaultOptions,
            ...this.options,
        })
    }

    disconnect() {
        this.sortable.destroy()
    }

    async onUpdate({ newIndex, oldIndex }) {
        // Handle table column reordering (if this is on a table header row)
        if (this.element.tagName === 'TR' && this.element.closest('thead')) {
            this.reorderTableColumns(oldIndex, newIndex)
            window.dispatchEvent(
                new CustomEvent('sortable:sorted', {
                    detail: {
                        columns: this.columnNameTargets.map(column => column.value),
                    },
                }),
            )
        }
    }

    reorderTableColumns(fromIndex, toIndex) {
        if (!this.table) return

        // Sortable.js has already moved the header cell, so we just need to sync the body cells
        // Move corresponding cells in all body rows

        const tbody = this.table?.querySelector('tbody')
        tbody.querySelectorAll('tr').forEach((row) => {
            const cells = Array.from(row.children)
            const movedCell = cells[fromIndex]

            // Skip if the cell doesn't exist
            if (!movedCell) return

            const targetCell = cells[toIndex > fromIndex ? toIndex + 1 : toIndex]

            if (targetCell) {
                row.insertBefore(movedCell, targetCell)
            } else {
                row.appendChild(movedCell)
            }
        })
    }

    onStart(evt) {
        // Add dragging class to table
        // This element = thead > tr, so find parent table
        this.table?.classList.add('table-columns-reordering')
    }

    onEnd(evt) {
        // Remove dragging classes
        this.table?.classList.remove('table-columns-reordering')
    }
}
